angular
  .module('data-ng-todos')
  .service(
    'loadPlacementTestScoresCommand',
    function loadPlacementTestScoresCommandDefinition($http, defineCommand, PlacementTestScoresBuilder) {
      return defineCommand('loadPlacementTestScoresCommand', function loadPlacementTestScoresCommand(deferred) {
        $http
          .get('/reg/placement/')
          .then(function (response) {
            deferred.resolve(new PlacementTestScoresBuilder(response.data));
          })
          .catch(function (e) {
            log.issue('failed to retrieve info for placement test scores');
            deferred.reject(e.data);
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/data/commands/load_placement_test_scores_command.js